"use client";
import React, { useContext } from "react";
import "./index.scss";
import Image from "next/image";
import {
  ABOUT_US_CALL,
  ABOUT_US_COOPERATION,
  ABOUT_US_JOIN_DISCORD,
  ABOUT_US_WHAT_APP_QR_CODE,
  JOIN_DISCORD_URL,
} from "@/cdn-resources";
import { clientWindow } from "@/utils/dom";
import { useTrackingRecordSave } from "@/api/track/use-query";
import { LoginContext } from "@/app/LoginProvider";
import {
  TrackingEventID,
  TrackingEventPageID,
  TrackingEventType,
} from "@/shared";

const JoinPage: React.FC = () => {
  const { mutate: fetchTrackingRecordSave } = useTrackingRecordSave();
  const loginCtx = useContext(LoginContext);

  const openWindowUrl = (url: string) => {
    fetchTrackingRecordSave({
      uid: loginCtx?.userInfo?.uid,
      event_id: TrackingEventID.JoinDiscord,
      event_type: TrackingEventType.Click,
      page_id: TrackingEventPageID.AboutUs,
    });
    clientWindow?.open(url, "_blank");
  };

  return (
    <div className="py-[100px] w-ful YF-join-wrapper flex flex-col items-center">
      <h2 className="title font-semibold">Welcome to YooFinds base</h2>
      <div className="subtitle">
        Discover high-commission products and bestselling products.
      </div>
      <div className="flex gap-6">
        <div className="p-1 bg-white cooperation-box">
          <Image
            src={ABOUT_US_COOPERATION}
            width={245}
            height={322}
            alt="cooperation"
            title={"Collaborating with YooFinds"}
          />
        </div>
        <div className="whatsapp-wrapper">
          <div className="flex justify-between items-center">
            <Image
              src={ABOUT_US_WHAT_APP_QR_CODE}
              width={140}
              height={132}
              alt="whatsapp-QRcode"
            />
            <div>
              <div className="flex items-center gap-2 whatapp-title">
                <Image
                  src={ABOUT_US_CALL}
                  width={29}
                  height={27}
                  alt="whatapp"
                />
                <span>WhatsApp</span>
              </div>
              <div className="text-base font-normal">
                Yoofinds Official Group
              </div>
            </div>
          </div>
          <ul className="text-textColor text-xs mt-4">
            <ol>Discover Popular Product Trends Premium</ol>
            <ol>Premium Influencer Support Program</ol>
            <ol>Connect with like-minded individuals</ol>
          </ul>
        </div>
        <div className="discord-wrapper">
          <div>
            If you have questions or suggestions, join our
            <span className="discord-text">Discord</span> community
          </div>
          <Image
            src={ABOUT_US_JOIN_DISCORD}
            width={161}
            height={24}
            alt="join discord"
            title={"join discord"}
            className="mt-10 cursor-pointer"
            onClick={openWindowUrl.bind(null, JOIN_DISCORD_URL)}
          />
        </div>
      </div>
    </div>
  );
};

export default JoinPage;
